import { IsOptional, IsString, IsEmail } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { MulterFile } from '@webundsoehne/nest-fastify-file-upload';
import { Type } from 'class-transformer';
import { JSONToClass } from '@/common/validators/json-to-class.decorator';

class UpdateProgramItemDto {
  @ApiProperty({ example: 1, description: 'Program ID' })
  @Type(() => Number)
  program_id!: number;

  @ApiProperty({ example: 2, description: 'Program type ID' })
  @Type(() => Number)
  type_id!: number;
}

export class UpdateUserDto {
  @ApiProperty({ example: 'John Doe', required: false })
  @IsOptional()
  @IsString()
  name?: string;

  @ApiProperty({ example: 'john@example.com', required: false })
  @IsOptional()
  @IsEmail()
  email?: string;

  @ApiProperty({ example: '+1234567890', required: false })
  @IsOptional()
  @IsString()
  phone?: string;

  @ApiProperty({
    type: String,
    format: 'binary',
    required: false,
    description: 'Profile image URL',
  })
  image_url?: MulterFile;

  @ApiProperty({
    type: String,
    required: false,
    description:
      'List of programs with associated type IDs (send as JSON string in multipart)',
    example: '[{"program_id":1,"type_id":2}]',
  })
  @IsOptional()
  @JSONToClass(UpdateProgramItemDto)
  programs?: UpdateProgramItemDto[];

  @ApiProperty({
    type: String,
    required: false,
    description:
      'List of category IDs (JSON string like "[1,2]" or CSV like "1,2,3")',
    example: '[1,2]',
  })
  @IsOptional()
  @JSONToClass(Number)
  category_ids?: number[];
}
